module.exports = __webpack_public_path__ + "img/rello-logo.52050e2a.svg";